import styled from 'styled-components'
import { respondTo } from '../../styles/_respondTo'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
    padding: 100px;
    padding-top: 20px;
    padding-bottom: 20px;
  `}

  ${respondTo.xl`
    padding: 250px;
    padding-top: 20px;
    padding-bottom: 20px;
  `}

`